import { useEffect } from 'react';

import type { ActiveReaction } from '../../types/reactions';
import { REACTION_IMAGE } from '../../utils/reactions';
import { FloatingReaction } from './components/FloatingReaction/FloatingReaction';
import { Wrapper } from './ReactionsOverlay.styled';

interface ReactionsOverlayProps {
  reactions: ActiveReaction[];
}

export const ReactionsOverlay = ({ reactions }: ReactionsOverlayProps) => {
  useEffect(() => {
    for (const src of Object.values(REACTION_IMAGE)) {
      const img = new Image();
      img.src = src;
    }
  }, []);

  if (reactions.length === 0) return null;

  return (
    <Wrapper>
      {reactions.map(reaction => (
        <FloatingReaction key={reaction.id} reaction={reaction} />
      ))}
    </Wrapper>
  );
};
